// Remembers where the operator was in a Deal Room before opening a contact,
// so "Back to deal" and browser back land on the same tab, section and scroll.
const MAX_AGE_MS = 30 * 60 * 1000;
const keyFor = (dealId) => `cf:dealroom:return:${dealId}`;
const liveTabs = {};

export const setLiveDealTab = (dealId, tab) => { if (dealId) liveTabs[dealId] = tab; };

export function saveDealReturnState(dealId, extra = {}) {
  if (!dealId) return;
  try {
    window.sessionStorage.setItem(keyFor(dealId), JSON.stringify({
      y: Math.round(window.scrollY || 0),
      tab: liveTabs[dealId] || null,
      at: Date.now(),
      ...extra,
    }));
  } catch { /* storage unavailable */ }
}

export function peekDealReturnState(dealId) {
  if (!dealId) return null;
  try {
    const s = JSON.parse(window.sessionStorage.getItem(keyFor(dealId)) || "null");
    return s && Date.now() - s.at < MAX_AGE_MS ? s : null;
  } catch { return null; }
}

export function clearDealReturnState(dealId) {
  try { window.sessionStorage.removeItem(keyFor(dealId)); } catch { /* noop */ }
}

// Waits until the page is tall enough (content loaded), then scrolls. Returns a cancel fn.
export function restoreDealScroll(y, onDone) {
  let tries = 0;
  const id = window.setInterval(() => {
    tries += 1;
    const tall = document.documentElement.scrollHeight >= y + window.innerHeight - 4;
    if (tall || tries > 60) {
      window.clearInterval(id);
      window.scrollTo(0, y);
      onDone?.();
    }
  }, 100);
  return () => window.clearInterval(id);
}
